exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue-text-color{color:#415ad4}.purple-text-color{color:#b43ceb}.red-text-color{color:#e13a3a}", ""]);

// exports
